<script>
import Section from '../../components/PageSection'
import { allAboutDates } from '../../mixins/allAboutDates'
// import Ajouter from '../../components/PageForm'

export default {
  name: 'addAgence',
  components: {
    Section,
    // Ajouter,
  },
  data(){
    return{
      user: null,
      agence: null,
      agences: [],
      erreurs: [],
      projets: [],

      //Pour chaque agence
      projetDeletionIsAllowed : {agenceId: "", state: false, projetId: ""}

    }
  },
  mixins:[
    allAboutDates,
  ],
  mounted(){
    this.$axios.get('agences')
    .then(response => this.agences = response.data)
    .catch(err => console.log(err))

    this.$axios.get('projets/all/')
    .then(response => this.projets = response.data)
    .catch(err => this.alert(err))
  },
  methods: {
    addAgence(){
      var formValid = true;
      this.erreurs = [];

      //Définition de l'agence
      var agence = {
        name: document.getElementById("agenceName").value,
        equivHJ: [{date: new Date("2000-01-01T00:00:00.000+00:00"), val: document.getElementById("equivHJ").value}],
        estimationsAnnuelles : {
          nbJours : [],
          nbCollaborateurs : [],
          totalCharges : [],
          salairesBruts : [],
          chargesDirectes : [],
          chargesIndirectes : [],
          salaireFacturable : [],
          marge : [],
        }
      }

      // Ajouter une valeur au nombre de jours moyen par mois pour les années 2000 à l'année en cours
      let anneeEnCours = new Date
      anneeEnCours = anneeEnCours.getUTCFullYear()

      for (let i = 2000; i < anneeEnCours; i++){ //Avec BLP, importés en 2021, ça n'a rien créé pour 2020...
        agence.estimationsAnnuelles.nbJours.push({annee: i, val: Math.round(this.joursOuvres(i, agence.alsace)/12*100)/100})
      }

      //Ajout des paramètres
      switch (document.querySelector('input[name="modeSaisie"]:checked').value){
        case 'heures' :
          //Saisie quotidienne (en heures)
          agence.modeSaisie = 1;
          break;
        case '' :
          //Saisie hebdo (INVALID)
          agence.modeSaisie = 2;
          formValid = false
          this.erreurs.push("Mode de saisie non valide")
          break;
        case 'jours' :
          //Saisie mensuelle (en jours)
          agence.modeSaisie = 3;
          break;
        default:
          formValid = false
          this.erreurs.push("Mode de saisie non valide")
          break;
      }

      if (document.getElementById("alsace").checked){
        agence.alsace = true;
      } else {
        agence.alsace = false;
      }


      //Définition de l'user principal
      var user = {
        email: document.getElementById("email").value,
        password: document.getElementById("password").value,
        passwordConfirm: document.getElementById("passwordConfirm").value,
        name: document.getElementById("name").value, //Casse : première lettre en majuscule, le reste en minuscule, sauf si espace ou tiret.
        surname: document.getElementById("surname").value, //Casse : première lettre en majuscule, le reste en minuscule, sauf si espace ou tiret.
        active: true,
        agenceId: null,
        salaire: [{date: "2000-01-01T00:00:00.000+00:00", val: 2500}],
      };

      //adresse mail valide
      if ( 
        !user.email.includes("@") || 
        !user.email.includes(".") ||
        user.email.indexOf(".", user.email.indexOf("@")) == -1
        ) {
        formValid = false;
        this.erreurs.push("adresse mail invalide");
      }
      //concordance des mots de passe
      if (user.password !== user.passwordConfirm){
        formValid = false;
        this.erreurs.push("mots de passe différents");
      }
      
      if(formValid){
        this.erreurs = [];
        //Création de la nouvelle agence dans la BDD
        this.$axios.post('agences/register', agence)
          .then(response => {
            this.alert(response);
            user.agenceId = response.data.agenceId;

            //-------------------------------
            // Rôles et Droits utilisateurs
            //-------------------------------
            let admin = {
              agenceId: user.agenceId,
              name: "Administrateur",
              isAdmin: true,
            }
            
            //ADMINISTRATEUR
            this.$axios.post('roles/register', admin)
            .then(roles => {
              this.$axios.get('ressources')
              .then(ressources => {
                for (let item of ressources.data){
                  if (item._id != "60faa0976c11aa4f08f60cd4"){ //Sortir la ressource 'ressources' de la liste, elle est réservé au super admin
                    let droit = {
                      agenceId      : user.agenceId,
                      roleId        : roles.data.roleId,
                      ressourceId   : item._id,
                      lecture       : true,
                      ecriture      : true,
                    }
                    this.$axios.post('droits/register', droit)
                  }
                }

                //J'ajoute le rôle "Administrateur" à l'utilisateur par defaut
                user.roleId = roles.data.roleId;

                //Création de l'utilisateur dans la BDD
                this.$axios.post('users/register', user)
                .then(response => {
                  console.log(response.data);
                })
                .catch(e => {
                  this.erreurs.push(e);
                  console.log(e);
                });
              })
            })
            
            //ADMINISTRATEUR (LECTURE SEULE)
            let adminLectureSeule = {
              agenceId: user.agenceId,
              name: "Administrateur (lecture seule)",
              isAdmin: false,
            }

            this.$axios.post('roles/register', adminLectureSeule)
            .then(roles => {
              this.$axios.get('ressources')
              .then(ressources => {
                for (let item of ressources.data){
                  if (item._id != "60faa0976c11aa4f08f60cd4"){ //Sortir la ressource 'ressources' de la liste, elle est réservé au super admin
                    let droit = {
                      agenceId      : user.agenceId,
                      roleId        : roles.data.roleId,
                      ressourceId   : item._id,
                      lecture       : true,
                      ecriture      : false,
                    }
                    this.$axios.post('droits/register', droit)
                  }
                }
              })
            })
            
            //COLLABORATEUR
            let collab = {
              agenceId: user.agenceId,
              name: "Collaborateur",
              default: true,
            }

            this.$axios.post('roles/register', collab)
            .then(roles => {
              let droit = {
                agenceId      : user.agenceId,
                roleId        : roles.data.roleId,
                ressourceId   : "60f1829f8b11645034abae6f", //temps passés
                lecture       : true,
                ecriture      : true,
              }
              this.$axios.post('droits/register', droit)
            })

            //----------------------
            // Coeffs
            //----------------------
            // Par défaut il faut les labels "Coût de revient Sphem" & "Prix de vente Sphem" pour chaque agence

            let itemCR = {
              agenceId  : user.agenceId,
              name      : "Coût de revient",
              active    : true,
              deleted   : false,
              sphem     : "cr",
              val       : 2,
              rank      : 1,
            }

            this.$axios.post('coeffLabels/register', itemCR)
            .then(response => {
              console.log(response.data.message)
              // itemCR._id = response.data.coeffId
            })
            .catch(e => console.log(e))

            let itemPV = {
              agenceId  : user.agenceId,
              name      : "Prix de vente",
              active    : true,
              deleted   : false,
              sphem     : "pv",
              val       : 2.2,
              rank      : 2,
            }

            this.$axios.post('coeffLabels/register', itemPV)
            .then(response => {
              console.log(response.data.message)
              // itemPV._id = response.data.coeffId
            })
            .catch(e => console.log(e))

            //-------------------------------
            // Listes par défaut
            //-------------------------------
            //Phases d'études
            let names = [
              "Concours",
              "Esquisse",
              "APS",
              "APD",
              "Permis de construire",
              "PRO",
              "DCE",
            ]

            let rank = 0
            for (let nom of names){
              let phase = {
                agenceId: user.agenceId,
                name: nom,
                type: 0,
                rank: rank++,
              }

              this.$axios.post('phaseLabels/register', phase)
              .then(response => {console.log(response.data.message)})
              .catch(e => {console.log(e)});
            }
            
            //Phases de chantier
            names = [
              "ACT",
              "EXE",
              "DET",
              "AOR",
            ]

            rank = 0
            for (let nom of names){
              let phase = {
                agenceId: user.agenceId,
                name: nom,
                type: 1,
                rank: rank++,
              }

              this.$axios.post('phaseLabels/register', phase)
              .then(response => {console.log(response.data.message)})
              .catch(e => {console.log(e)});
            }

            //Missions complémentaires
            names = [
              "Signalétique",
              "Mobilier",
            ]

            rank = 0
            for (let nom of names){
              let phase = {
                agenceId: user.agenceId,
                name: nom,
                type: 2,
                rank: rank++,
              }

              this.$axios.post('phaseLabels/register', phase)
              .then(response => {console.log(response.data.message)})
              .catch(e => {console.log(e)});
            }

            //Tâches non facturables
            names = [
              "Administratif",
              "Candidatures",
              "Expertises",
            ]

            rank = 0
            for (let nom of names){
              let tache = {
                agenceId: user.agenceId,
                name: nom,
                rank: rank++,
                //type: 1, //1: tache | 2: absence
              }

              this.$axios.post('nonFact/register', tache)
              .then(response => {console.log(response.data.message)})
              .catch(e => {console.log(e)});
            }

            //Absences et congés
            names = [
              "Congés payés",
              "Congés Maternité / Paternité",
              "Arrêt maladie",
              "RTT",
              "Heures de récupération",
              "Congés sans solde",
            ]

            rank = 0
            for (let nom of names){
              let absence = {
                agenceId: user.agenceId,
                name: nom,
                rank: rank++,
              };  

              this.$axios.post('absences/register', absence)
              .then(response => {console.log(response.data.message)})
              .catch(e => {console.log(e)});
            }

            //Frais & prestas
            names = [
              "BET Structure",
              "BET Fluides",
              "BET Accoustique",
              "BET Paysage",
              "Perspectives",
              "Maquettes",
              "Déplacements",
              "Frais de bouche",
            ]

            rank = 0
            for (let nom of names){
              let fraisItem = {
                agenceId: user.agenceId,
                name: nom,
                rank: rank++,
              };

              this.$axios.post('frais/register', fraisItem)
              .then(response => {console.log(response.data.message)})
              .catch(e => {console.log(e)});
            }


            //-------------------------------------------------------
            //  Fin de la configuration
            //-------------------------------------------------------
          })
          .catch(e => {
            this.erreurs.push(e);
            console.log(e);
          });
        
        
      } else {
        console.log(this.erreurs);
      }
    },
    //Liste des projets par agence
    projetsByAgence(agenceId){
      return this.projets.filter(e => e.agenceId == agenceId)
    },
    //Vérifier si un projet est supprimable : s'il n'y a pas de feuilles de saisie
    async isDeletableProjet(projetId, agenceId){
      if (projetId != ""){
        //Seule exception, s'il y a des feuilles de saisies associées, je ne peux pas supprimer.
        let feuilles = []
        await this.$axios.get('feuilles/getByAgence/' + agenceId)
        .then(response => feuilles = response.data)
        .catch(err => this.alert(err))

        //Par defaut je pars du principe qu'il n'y a pas de feuille
        let thereIsOne = false
        for (let feuille of feuilles){
          for (let item of feuille.data){
            if (item.projetId == projetId){
              //Si j'en trouve une j'arrête tout
              thereIsOne = true
              break;
            }
          }
        }

        if (!thereIsOne){
          this.projetDeletionIsAllowed = {agenceId: agenceId, state: true, projetId: projetId}
        } else {
          this.alert("Supression impossible, feuilles de saisie associées")
        }
      }
    },
    //Supprimer un projet et tout ce qui le concerne de façon brutale, compris temps passés.
    deleteProjet(projetId, agenceId){
      this.$axios.delete('projets/' + projetId + "/" + agenceId)
      .then(response => {
        this.alert(response)
        
        //Suppression sur le client
        this.projets.splice(this.projets.findIndex(e => e._id == projetId), 1)

        //Remise à zéro de l'objet de suppression
        this.projetDeletionIsAllowed = {agenceId: "", state: false, projetId: ""}
      })
      .catch(err => this.alert(err))
    },
    //Supprimer une agence et tout ce qu'elle contient de façon brutale
    // deleteAgence(agenceId){

    // },



    //Traitement spécifiques si l'agence est déjà créée.
    async initializeOne(agenceId){
      let agence = {}
      await this.$axios.get('agences/' + agenceId)
      .then(response => agence = response.data)
      .catch(e => console.log(e))
      console.log(agence)  

      // let adminLectureSeule = {
      //   agenceId: agence._id,
      //   name: "Administrateur (lecture seule)",
      //   isAdmin: true,
      // }

      // this.$axios.post('roles/register', adminLectureSeule)
      // .then(roles => {
      //   this.$axios.get('ressources')
      //   .then(ressources => {
      //     for (let item of ressources.data){
      //       if (item._id != "60faa0976c11aa4f08f60cd4"){ //Sortir la ressource 'ressources' de la liste, elle est réservé au super admin
      //         let droit = {
      //           agenceId      : agence._id,
      //           roleId        : roles.data.roleId,
      //           ressourceId   : item._id,
      //           lecture       : true,
      //           ecriture      : false,
      //         }
      //         this.$axios.post('droits/register', droit)
      //       }
      //     }
      //   })
      // })
    },
    initializeAll(){
      for (let item of this.agences){
        this.initializeOne(item._id)
      }
    },
    resetDates(){
      this.$axios.get('users')
      // this.$axios.get('users/allInAgence/' + this.$store.state.auth.currentAgence._id)
      .then(users => {
        for (const user of users.data) {

          for (const salaire of user.salaire){
            let myDate = new Date(salaire.date)
            myDate.setUTCHours(0)
            myDate.setUTCMinutes(0)
            myDate.setUTCSeconds(0)
            myDate.setUTCMilliseconds(0)
            salaire.date = myDate.toISOString()
          }

          this.$axios.put('users/' + user._id, user)
          .then(res => console.log(res))
          .catch(err => console.log(err))

        }
      })
      .catch(err => console.log(err))
    }
  },
}
</script>


<template>
    <div>
      <Section text="Ajouter une agence" underlined="true">
        <template v-slot:body>
          <form class="container" @submit.prevent="addAgence()">
            <div class="container-essentials">
              <div class="container-line"><label class="container-topLabel">Nom de l'agence : </label><input id="agenceName" type="text" class="container-name" required       value="Agence BLP Test"></div>
              <div class="container-line"><label class="container-topLabel">Adresse mail de contact : </label><input id="email" type="text" class="container-name" required    value="blp@blp.fr"></div>
              <div class="container-line"><label class="container-topLabel">Prénom : </label><input id="name" type="text" class="container-name" required                      value="Compte"></div>
              <div class="container-line"><label class="container-topLabel">Nom : </label><input id="surname" type="text" class="container-name" required                      value="Test"></div>
              <div class="container-line"><label class="container-topLabel">Mot de passe : </label><input id="password" type="password" class="container-name" required        value="blp"></div>
              <div class="container-line"><label class="container-topLabel">Confirmation : </label><input id="passwordConfirm" type="password" class="container-name" required value="blp"></div>
            </div>
            <div class="container-params">
              <div class="container-line2">
                <label class="container-topLabel">Mode de saisie : </label>
                <div><input type="radio" name="modeSaisie" required value="heures" checked><label class="container-topLabel" >Heures</label></div>
                <div><input type="radio" name="modeSaisie" required value="jours"><label class="container-topLabel" >jours</label></div>
              </div>
              <div class="container-line2"><label class="container-topLabel">EquivHJ : </label><input id="equivHJ" type="number" min="0" step="0.1" class="container-name" required value="7.8"></div>
              <div class="container-line2"><label class="container-topLabel">Alsace / Moselle : </label><input id="alsace" type="checkbox">Oui</div>
            </div>
            <input id="submit" type="submit">
          </form>
          <div class="erreurs">
            <div v-for="item in erreurs" :key="item">{{item}}</div>
          </div>
        </template>
      </Section>

      <Section text="Agences enregistrées" class="agences" underlined="true">
        <template v-slot:body>
          <div v-for="agence in agences" :key="agence._id" class="agence__item">
            <div class="agence__item-name"> {{agence.name}} </div>
            <div  class="agence__item-deleteProjet">
              <label>Supprimer un projet :</label>
              <select @change="isDeletableProjet($event.target.value, agence._id)">
                <option value=""> -- </option>
                <option :value="item._id" v-for="item in projetsByAgence(agence._id)" :key="item._id"> {{item.name}} </option>
              </select>
              <div class="material-icons" v-if="projetDeletionIsAllowed.agenceId == agence._id && projetDeletionIsAllowed.state" @click="deleteProjet(projetDeletionIsAllowed.projetId, agence._id)">delete_outline</div>
            </div>
            <button @click="initializeOne(agence._id)">Initialize</button>
          </div>
        </template>
      </Section>
      <button @click="initializeAll()">Compléter l'initialisation de toutes les agences</button>

      <Section text="Modifications globales de la base de données" underlined="true">
        <template v-slot:body>
          <button @click="resetDates()">Remettre à zéro les heures des dates de modification des salaires des utilisateurs</button>
        </template>
      </Section>
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.container{
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 7%;
  margin: 0 0 20px 0;

  &-line{
    display: flex;
    justify-content: flex-end;
    margin: 0 0 3px 0;
  }

  &-line2{
    display: flex;
    margin: 0 0 3px 0;
    @include myFont;
    font-size: 13px;
  }

  &-topLabel{
    @include myFont;
    font-size: 13px;
    position: relative;
    top: 1px;
    margin: 0 15px 0 0;
  }

  &-name{
    border: none;
    @include myFont;
    font-size: 13px;
    border-radius: 5px;;
    padding: 0 5px;
    width: 70%;
  }
}

#submit{
  padding: 5px 15px 5px 15px;
  width: 40%;
  margin: 30px 0 10px 0;
  @include myButton;
  grid-column: 1 / span 2;
  justify-self: center;
}

.erreurs{
  display: flex;
  justify-content: center;
  color: $alert;
  @include myFont;
  font-size: 13px;
}

.agence{
  
  &__item{
    @include myBlock;
    padding: 5px;
    margin: 0 0 5px 0;

    &-name{
      @include myFont;
      color: $main;
      font-size: 13px;
      font-weight: 600;
      margin: 0 0 15px 0;
    }

    &-deleteProjet{
      display: flex;

      & label{
        @include myFont;
        font-size: 13px;
        margin: 0 15px 0 0;
      }

    }
  }
}

</style>
